import React, { useState } from 'react'

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

function SurveyOnlineReport(props) {
    const { averageWeek, guestOpinion, calculatorWeek, dataChart, oldMonth, role, checkSend, branchID } = props;
    const [typeView, setTypeView] = useState("thisMonth");
    const [hiddenPaperSurvey, setHiddenPaperSurvey] = useState(false);
    const isNotHidden = branchID === 11 ? "" : " op-hidden"

    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend
    );
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
            title: {
                display: true,
                text: 'Survey Chart',
            },
        },
    };
    function renderTableScore() {
        var result = [];
        const weekOnAverageWeek = Object.keys(averageWeek);
        weekOnAverageWeek.forEach(week => {
            return result.push(<tr>
                <td style={{ fontSize: '1.2rem' }}>{week}</td>
                <td style={{ fontSize: '1.2rem' }}>{calculatorWeek[week].reception > 0 ? calculatorWeek[week].reception : ""}</td>
                <td style={{ fontSize: '1.2rem' }}>{calculatorWeek[week].azuman > 0 ? calculatorWeek[week].azuman : ""}</td>
                <td style={{ fontSize: '1.2rem' }}>{calculatorWeek[week].kitchen > 0 ? calculatorWeek[week].kitchen : ""}</td>
                <td style={{ fontSize: '1.2rem' }}>{calculatorWeek[week].hk > 0 ? calculatorWeek[week].hk : ""}</td>
                <td style={{ fontSize: '1.2rem' }}>{calculatorWeek[week].roten > 0 ? calculatorWeek[week].roten : ""}</td>
                <td style={{ fontSize: '1.2rem' }}>{calculatorWeek[week].massage > 0 ? calculatorWeek[week].massage : ""}</td>
                <td className={isNotHidden}>{calculatorWeek[week].server > 0 ? calculatorWeek[week].server : ""}</td>
                <td className={isNotHidden}>{calculatorWeek[week].maintainer > 0 ? calculatorWeek[week].maintainer : ""}</td>
            </tr>)
        });

        result.push(<tr>
            <td>Total</td>
            <td style={{ fontSize: '1.2rem' }}>{calculatorWeek["Month"].reception}</td>
            <td style={{ fontSize: '1.2rem' }}>{calculatorWeek["Month"].azuman}</td>
            <td style={{ fontSize: '1.2rem' }}>{calculatorWeek["Month"].kitchen}</td>
            <td style={{ fontSize: '1.2rem' }}>{calculatorWeek["Month"].hk}</td>
            <td style={{ fontSize: '1.2rem' }}>{calculatorWeek["Month"].roten}</td>
            <td style={{ fontSize: '1.2rem' }}>{calculatorWeek["Month"].massage}</td>
            <td className={isNotHidden}>{calculatorWeek["Month"].server}</td>
            <td className={isNotHidden}>{calculatorWeek["Month"].maintainer}</td>

        </tr>);
        return result
    }

    function renderCompare2MonthsTableScore() {
        var result = [];
        const DifferenceRC = Math.round((calculatorWeek["Month"].reception - oldMonth.calculatorWeek["Month"].reception) * 100) / 100;
        const DifferenceAzuman = Math.round((calculatorWeek["Month"].azuman - oldMonth.calculatorWeek["Month"].azuman) * 100) / 100;
        const DifferenceKitchen = Math.round((calculatorWeek["Month"].kitchen - oldMonth.calculatorWeek["Month"].kitchen) * 100) / 100;
        const DifferenceHK = Math.round((calculatorWeek["Month"].hk - oldMonth.calculatorWeek["Month"].hk) * 100) / 100;
        const DifferenceRoten = Math.round((calculatorWeek["Month"].roten - oldMonth.calculatorWeek["Month"].roten) * 100) / 100;
        const DifferenceMassage = Math.round((calculatorWeek["Month"].massage - oldMonth.calculatorWeek["Month"].massage) * 100) / 100;
        const DifferenceServer = Math.round((calculatorWeek["Month"].server - oldMonth.calculatorWeek["Month"].server) * 100) / 100;
        const DifferenceMaintainer = Math.round((calculatorWeek["Month"].maintainer - oldMonth.calculatorWeek["Month"].maintainer) * 100) / 100;

        result.push(<>
            <tr>
                <td style={{ fontSize: '1.2rem' }}>This Month</td>
                <td style={{ fontSize: '1.2rem' }}>{calculatorWeek["Month"].reception}</td>
                <td style={{ fontSize: '1.2rem' }}>{calculatorWeek["Month"].azuman}</td>
                <td style={{ fontSize: '1.2rem' }}>{calculatorWeek["Month"].kitchen}</td>
                <td style={{ fontSize: '1.2rem' }}>{calculatorWeek["Month"].hk}</td>
                <td style={{ fontSize: '1.2rem' }}>{calculatorWeek["Month"].roten}</td>
                <td style={{ fontSize: '1.2rem' }}>{calculatorWeek["Month"].massage}</td>
                <td style={{ width: '70px', fontSize: '1.2rem' }} className={isNotHidden}>
                    {calculatorWeek["Month"].server}</td>
                <td style={{ width: '70px', fontSize: '1.2rem' }} className={isNotHidden}>
                    {calculatorWeek["Month"].maintainer}</td>
            </tr>
            <tr>
                <td style={{ fontSize: '1.2rem' }}>Old Month</td>
                <td style={{ fontSize: '1.2rem' }}>{oldMonth.calculatorWeek["Month"].reception}</td>
                <td style={{ fontSize: '1.2rem' }}>{oldMonth.calculatorWeek["Month"].azuman}</td>
                <td style={{ fontSize: '1.2rem' }}>{oldMonth.calculatorWeek["Month"].kitchen}</td>
                <td style={{ fontSize: '1.2rem' }}>{oldMonth.calculatorWeek["Month"].hk}</td>
                <td style={{ fontSize: '1.2rem' }}>{oldMonth.calculatorWeek["Month"].roten}</td>
                <td style={{ fontSize: '1.2rem' }}>{oldMonth.calculatorWeek["Month"].massage}</td>
                <td style={{ width: '70px', fontSize: '1.2rem' }} className={isNotHidden}>
                    {oldMonth.calculatorWeek["Month"].server}</td>
                <td style={{ width: '70px', fontSize: '1.2rem' }} className={isNotHidden}>
                    {oldMonth.calculatorWeek["Month"].maintainer}</td>
            </tr>
            <tr className="op-fontweight600">
                <td style={{ fontSize: '1.2rem' }}>Difference</td>
                <td style={{ fontSize: '1.2rem' }} className={DifferenceRC < 0 ? "op-redcolor" : ""}>{DifferenceRC}</td>
                <td style={{ fontSize: '1.2rem' }} className={DifferenceAzuman < 0 ? "op-redcolor" : ""}>{DifferenceAzuman}</td>
                <td style={{ fontSize: '1.2rem' }} className={DifferenceKitchen < 0 ? "op-redcolor" : ""}>{DifferenceKitchen}</td>
                <td style={{ fontSize: '1.2rem' }} className={DifferenceHK < 0 ? "op-redcolor" : ""}>{DifferenceHK}</td>
                <td style={{ fontSize: '1.2rem' }} className={DifferenceRoten < 0 ? "op-redcolor" : ""}>{DifferenceRoten}</td>
                <td style={{ fontSize: '1.2rem' }} className={DifferenceMassage < 0 ? "op-redcolor" : ""}>{DifferenceMassage}</td>
                <td style={{ fontSize: '1.2rem' }} className={(DifferenceMaintainer < 0 ? "op-redcolor" : "")
                    + (isNotHidden)}>{DifferenceServer}</td>
                <td style={{ fontSize: '1.2rem' }} className={(DifferenceMaintainer < 0 ? "op-redcolor" : "")
                    + (isNotHidden)}>{DifferenceMaintainer}</td>
            </tr>
            <tr>
                <td>-</td><td>-</td><td>-</td><td>-</td><td>-</td><td>-</td><td>-</td>
                <td style={{ width: '70px' }} className={isNotHidden}>-</td>
                <td style={{ width: '70px' }} className={isNotHidden}>-</td>
            </tr>
            <tr>
                <td>-</td><td>-</td><td>-</td><td>-</td><td>-</td><td>-</td><td>-</td>
                <td style={{ width: '70px' }} className={isNotHidden}>-</td>
                <td style={{ width: '70px' }} className={isNotHidden}>-</td>
            </tr>

        </>);
        return result
    }

    function renderTableGuestOpinion() {
        var result = [];
        var count = 0;
        const listKeyOnGuestOpinion = Object.keys(guestOpinion);
        //+ " @" + opnion.mtime
        listKeyOnGuestOpinion.forEach(week => {
            if (guestOpinion[week].length > 0) {
                result.push(<tr>
                    <td className="bg_yellow" colspan="5">{week.toUpperCase()}</td>
                </tr>)
                guestOpinion[week].forEach((opinion, index) => {
                    count += 1;
                    return result.push(
                        <tr className={(hiddenPaperSurvey && opinion.mcau8.toLowerCase().includes("paper survey")) ? "op-hidden" : ""}>
                            <td style={{ fontSize: '1.2rem' }}>{count}</td>
                            <td style={{ fontSize: '1.2rem' }}>{opinion.mdate}</td>
                            <td style={{ fontSize: '1.2rem' }}>{opinion.room_number}</td>
                            <td style={{ fontSize: '1.2rem' }}><textarea style={{ width: '100%' }}
                                disabled="true">
                                {opinion.mcau8}</textarea>
                            </td>
                            <td style={{ fontSize: '1.2rem' }}>
                                <textarea style={{ width: '100%' }}
                                    onBlur={e => props.updateNoteToServer(e.target.value, opinion, week, index)}
                                    disabled={(role === 3 && checkSend) ? false : true}>
                                    {opinion.mnotechange}
                                </textarea></td>
                        </tr >)

                })
            }
        })
        return result
    }

    return (
        <React.Fragment >
            <div className="d-flex survey_online"
                style={{ with: '100%' }}>

                <div className="survey_online-report mr-3 mb-5 ml-3 col"  // mr-5 mb-5 ml-5
                    style={{ width: '60%' }}
                >
                    <h1>Month Score Survey</h1>
                    <div>
                        <div className="nav nav-tabs nav-fill survey_report_select mb-3" role="tablist">
                            <span className="nav-item nav-link survey_report_select-item"
                                onClick={() => setTypeView("thisMonth")}
                                style={{ backgroundColor: 'pink', color: 'black', fontWeight: '600', cursor: "pointer", opacity: typeView === "thisMonth" ? "1" : "0.5" }}>
                                Score Table this Month</span>
                            <span className="nav-item nav-link survey_report_select-item"
                                onClick={() => setTypeView("twoMonths")}
                                style={{ backgroundColor: 'pink', color: 'black', fontWeight: '600', cursor: "pointer", opacity: typeView !== "thisMonth" ? "1" : "0.5" }}>
                                Difference 2 Months</span>
                        </div>
                        <table id="customers" className={typeView === "thisMonth" ? "" : "op-hidden"}>
                            <tr>
                                <th style={{ width: '70px' }}>Week</th>
                                <th style={{ width: '70px' }}>Reception</th>
                                <th style={{ width: '70px' }}>Azuman</th>
                                <th style={{ width: '70px' }}>Kitchen</th>
                                <th style={{ width: '70px' }}>HK</th>
                                <th style={{ width: '70px' }}>Roten</th>
                                <th style={{ width: '70px' }}>Massage</th>
                                <th style={{ width: '70px' }} className={isNotHidden}>
                                    Server</th>
                                <th style={{ width: '70px' }} className={isNotHidden}>
                                    Maintainer</th>
                            </tr>

                            {renderTableScore()}
                        </table>
                        <table id="customers" className={typeView !== "thisMonth" ? "" : "op-hidden"}>
                            <tr>
                                <th style={{ width: '70px' }}>Week</th>
                                <th style={{ width: '70px' }}>Reception</th>
                                <th style={{ width: '70px' }}>Azuman</th>
                                <th style={{ width: '70px' }}>Kitchen</th>
                                <th style={{ width: '70px' }}>HK</th>
                                <th style={{ width: '70px' }}>Roten</th>
                                <th style={{ width: '70px' }}>Massage</th>
                                <th style={{ width: '70px' }} className={isNotHidden}>
                                    Server</th>
                                <th style={{ width: '70px' }} className={isNotHidden}>
                                    Maintainer</th>
                            </tr>
                            {renderCompare2MonthsTableScore()}
                        </table>
                    </div>

                    <span>-----</span>
                    <div className="mt-5 " id="chartSurvey">
                        <h1>Survey Chart Month</h1>
                        <Bar options={options} data={dataChart} />
                    </div>
                </div>

                <div className="col mr-3 survey_online-feedback"
                    style={{ borderLeft: '1px solid #333', maxHeight: '800px', overflowX: 'scroll', width: '40%' }}>
                    <h1>Guest Feedback</h1>
                    <h4>* Supervisor can note on [Supervisor Reply], automatic update on server and show on report mail*</h4>
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '12px' }}>
                        <h4 for="vehicle3" style={{ color: 'rgb(72, 41, 121)' }}>( Hidden Paper Survey</h4>
                        <input className="ml-2" type="checkbox" name="vehicle3" value="Boat" onChange={() => setHiddenPaperSurvey(!hiddenPaperSurvey)} />
                        <h4 for="vehicle3" style={{ color: 'rgb(72, 41, 121)' }}>)</h4>
                    </div>
                    <table id="customers" className="ml-3">
                        <tr >
                            <th style={{ width: "70px", fontSize: '1.2rem' }}>NO.</th>
                            <th style={{ width: "100px", fontSize: '1.2rem' }}>Time</th>
                            <th style={{ width: "70px", fontSize: '1.2rem' }}>Room</th>
                            <th style={{ width: "400px", fontSize: '1.2rem' }}>Feedback / Opinion</th>
                            <th style={{ width: "250px", fontSize: '1.2rem' }}>Supervisor Reply</th>
                        </tr>
                        {renderTableGuestOpinion()}
                    </table>
                </div>

            </div>
        </React.Fragment >
    )
}
export default SurveyOnlineReport
